import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import * as uuid from 'uuid/v4';

import { APIError } from '../lib/errors';
import helpers from '../lib/helpers';

const firebaseConfig = {
  apiKey: "AIzaSyDzpBx686p169LpyvuDgxXQuHllxfArXsw",
  authDomain: "leon-altstadt-1v1me.firebaseapp.com",
  databaseURL: "https://leon-altstadt-1v1me.firebaseio.com",
  projectId: "leon-altstadt-1v1me",
  storageBucket: "leon-altstadt-1v1me.appspot.com",
  messagingSenderId: "421199952326",
  appId: "1:421199952326:web:0c765e6025e9f01b449ac7"
};

firebase.initializeApp(firebaseConfig);

const database = firebase.firestore();

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: {
      summoner: null,
      email: null,
      uid: null
    },
    snack: null,
    match: {
      createdAt: null,
      host: null,
      guest: null,
      champion: null,
      wager: null,
      status: null,
      private: null
    },
    matches: null
  },
  mutations: {
    setUser(state, payload) {
      state.user.status = payload.status;
      state.user.summoner = payload.summoner;
      state.user.rank = payload.rank;
      state.user.email = payload.email;
      state.user.verified = payload.verified;
      state.user.uid = payload.uid;
    },
    setSnack(state, payload) {
      state.snack = payload;
    },
    setMatch(state, payload) {
      state.match.createdAt = payload.createdAt;
      state.match.host = payload.host;
      state.match.guest = payload.guest;
      state.match.champion = payload.champion;
      state.match.wager = payload.wager;
      state.match.status = payload.status;
      state.match.private = payload.private;
    },
    setMatches(state, payload) {
      state.matches = payload;
    }
  },
  actions: {
    async signUp({ commit }, payload) {
      try {
        const summoner = await helpers.fetchFromAPI(`https://leon-altstadt-api.herokuapp.com/summoner/register?summoner=${payload.summonerName}&region=${payload.region}`);
        const { user } = await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password);
        
        await database.collection('users').doc(user.uid).set({
          summoner: summoner,
          consent: payload.consent
        });
      }
      catch(error) {
        //console.error(error);
        
        if(error instanceof APIError) {
          commit('setSnack', error.message);
        }

        throw error;
      }
    },
    async signIn(context, payload) {
      try {
        await firebase.auth().signInWithEmailAndPassword(payload.email, payload.password);
      }
      catch(error) {
        throw error;
      }
    },
    async logout() {
      try {
        await firebase.auth().signOut();
      }
      catch(error) {
        throw error;
      }
    },
    async createMatch({ commit, state }, payload) {
      try {
        if(state.user.uid === null) {
          throw Error('Cannot create match, not logged in');
        }

        const uid = uuid();
        const host = {
          summoner: {
            name: state.user.summoner.name,
            icon: state.user.summoner.profileIconId,
            tier: state.user.summoner.rank.tier,
            stats: []
          },
          uid: state.user.uid
        };

        await database.collection('matches').doc(uid).set({
          createdAt: new Date().toUTCString(),
          champion: payload.champion,
          host: host,
          guest: null,
          wager: payload.wager,
          private: payload.private,
          status: 'WAITING_FOR_PLAYER',
          uid: uid
        });

        return uid;
      }
      catch(error) {
        //console.error(error);
        
        if(error instanceof APIError) {
          commit('setSnack', error.message);
        }

        throw error;
      }
    },
    async fetchMatch({ commit }, payload) {
      try {
        const match = await database.collection('matches').doc(payload).get();

        if(!match.exists) {
          throw new Error('Match does not exist');
        }
        
        const data = match.data();

        commit('setMatch', data);
      }
      catch(error) {
        //console.error(error);
        
        if(error instanceof APIError) {
          commit('setSnack', error.message);
        }

        throw error;
      }
    },
    async fetchMatches({ commit }) {
      try {
        const matches = await database.collection('matches').get();

        if(matches.size === 0) {
          commit('setMatches', []);
        }
        else {
          const data = [];

          matches.forEach(document => {
            data.push(document.data());
          });

          commit('setMatches', data);
        }
      }
      catch(error) {
        //console.error(error);
        
        if(error instanceof APIError) {
          commit('setSnack', error.message);
        }

        throw error;
      }
    }
  }
});

firebase.auth().onAuthStateChanged(async user => {
  try {
    let information = {
      summoner: null,
      email: null,
      uid: null
    };

    if(user) {
      const document = await database.collection('users').doc(user.uid).get();
      const data = document.data();

      information = {
        summoner: data.summoner,
        email: user.email,
        uid: user.uid
      };
    }

    store.commit('setUser', information);
  }
  catch(error) {
    //console.error(error);
  }
});

export default store;
